import {debug} from 'loglevel'
import { toc_options } from "@/site_settings"
import mock_search_results from "@/../mockdata/q.json"
import bio_articles from "@/../mockdata/bio_articles.json"

function mock_json_(rs, timeout = 1000) {
  const promise1 = new Promise((resolve) => {
    setTimeout(() => {
      resolve(rs);
    }, timeout);
  });
  return promise1;
}

function get_toc_m() {
  return mock_json_(toc_options, 200)
}

function search_m(q, load_from=0) {
  return mock_json_(mock_search_results, 1000)
}

function get_journal_m(uniname) {
}

function get_toc_name_(toc, id) {
  if(toc.id.toLowerCase() === id.toLowerCase()) {
    // debug(log(toc, toc.name, toc.id, id)
    return toc.name;
  }

  try {
    for(var i = 0; i < toc.children.length; i++) {
      var e = toc.children[i];
      var r = get_toc_name_(e, id);
      if(r !== null) {
        return r
      }
    }
  }
  catch(TypeError) {
    return null;
  }
  return null;
}

function get_toc_name_m(id) {
  for(var i = 0; i < toc_options.length; i++) {
    var toc = toc_options[i];
    var r = get_toc_name_(toc, id)
    if(r !== null) {
      return r
    }
  }
  return null;
}

export {search_m, get_toc_m, get_journal_m, get_toc_name_m}
